const getFormattedActionsHistory = () => {
    const pageViews = [];

    try {
        const hashRegex = /(#.+)\??/g;
        const coveoAnalyticsKey = '__coveo.analytics.history';
        let coveoAnalyticsRaw = '';

        if (window.localStorage) {
            coveoAnalyticsRaw = window.localStorage.getItem(coveoAnalyticsKey);
        }

        const coveoAnalytics = JSON.parse(coveoAnalyticsRaw);
        pageViews.push(...coveoAnalytics.filter(coveoAnalytic => coveoAnalytic.name === 'PageView').slice(0, 10));
        pageViews.forEach(coveoAnalytic => coveoAnalytic.value = coveoAnalytic.value.replace(hashRegex, ''));
    } catch (err) {
        console.warn('Could not parse Coveo Analytics');
    }

    return JSON.stringify(pageViews);
};

const getContextualRecommendations = (options = {}) => {
    const payload = { ...options };
    
    if (typeof CoveoWebsite?.coveoPlatform?.context !== 'undefined'
        && Object.entries(CoveoWebsite.coveoPlatform.context)) {
        payload.context = CoveoWebsite.coveoPlatform.context;
    }

    return getResourcesFromPlatform(payload);
};

const getRecommendations = (options = {}) => {
    const payload = { ...options };

    payload.additionalParameters = [
        `actionsHistory=${getFormattedActionsHistory()}`
    ];

    if (options.coveoPlatform.pipeline) {
        payload.additionalParameters.push(`pipeline=${options.coveoPlatform.pipeline}`);
    }
    
    if (window.localStorage) {
        return getResourcesFromPlatform(payload);
    }
};

const getResourcesFromPlatform = (options = {}) => {
    return new Promise((resolve, reject) => {
        if (!options?.coveoPlatform) {
            return resolve({
                resources: []
            });
        }

        const additionalParameters = options.additionalParameters || [];
        const query = options.query || {};
        const orgId = options.coveoPlatform.orgId;

        const config = {
            headers: {
                'Authorization': `Bearer ${options.coveoPlatform.apiToken}`
            }
        };

        if (options.abortController) {
            config.signal = options.abortController.signal;
        }

        if ('context' in options) {
            query.context = { ...options.context };
        }

        let url = `${CoveoWebsite.coveoPlatform.baseUrl}/rest/search/v2?organizationId=${orgId}`;

        if (additionalParameters.length) {
            url += `&${additionalParameters.join('&')}`;
        }

        http.post(url, query, config)
            .then(response => {
                if (response
                    && response.data) {
    
                    const resources = [];

                    response.data.results.forEach(resourceData => {
                        if (resourceData
                            && resourceData.raw
                            && resourceData.raw.maintitle
                            && resourceData.raw.culture === lang) {

                            const newResource = {
                                id: resourceData.raw.permanentid,
                                title: resourceData.raw.maintitle,
                                timeInfo: resourceData.raw.resourcetimeinfo,
                                shortDescription: resourceData.raw.shortdescription || resourceData.excerpt,
                                annotation: resourceData.raw.resourceannotation,
                                inlineTagging: resourceData.raw.resourceinlinetagging,
                                callToAction: resourceData.raw.resourcecalltoaction,
                                externalUrl: resourceData.raw.resourceez120xternallink || resourceData.raw.registrationlink,
                                landingUrl: resourceData.raw.registrationlink || resourceData.raw.clickableuri,
                                lowqualityvideourl: resourceData.raw.lowqualityvideourl,
                                videoThumbnailTrimStart: resourceData.raw.videothumbnailtrimstart,
                                eventStartDate: resourceData.raw.eventstartdate,
                                type: {
                                    label: resourceData.raw.resourcetypename,
                                    linkLabel: resourceData.raw.resourcecalltoaction,
                                    singularLabel: resourceData.raw.resourcetypenamesingular
                                },
                                videoId: resourceData.raw.resourcevideoid
                            };

                            if (resourceData.raw.thumbnailurl) {
                                newResource.thumbnail = {
                                    alt: '',
                                    src: resourceData.raw.thumbnailurl.replace('/sitecore/shell', '')
                                };
                            }

                            resources.push(newResource);
                        }
                    });

                    resolve({
                        resources,
                        totalCount: response.data.totalCount
                    });
                }
            }).catch((err) => {
                if (err?.message !== 'canceled') {
                    throw new Error(err);
                }
            });
    });
};

export {
    getFormattedActionsHistory,
    getContextualRecommendations,
    getRecommendations,
    getResourcesFromPlatform
};